import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import { Button } from '@startengine/design-system.ui.button';
import { colors } from '@startengine/design-system.theme.main';

export const OwnersBox = styled(Grid)(({ theme }) => ({
  background: colors.SECream,
  borderRadius: '1rem',
  padding: '14px 24px',
  height: '100%',
  [theme.breakpoints.up('sm')]: {
    padding: '10px',
  },
  '.ImageSpan > span > span': {
    height: '38px !important',
    width: '38px !important',
  },
}));

export const RewardBox = styled(Grid)(({ theme }) => ({
  width: '100%',
  '.MuiBox-root': {
    flexDirection: 'column',
    '.MuiBox-root': {
      flexDirection: 'row',
      maxWidth: '400px',
      margin: '20px 5px 20px 5px',
      padding: '10px',
      alignItems: 'center',
      '.MuiTypography-p3SemiBold': {
        height: '100px',
        overflowY: 'auto',
        fontWeight: 600,
        color: colors.SEBlack,
      },
    },
  },

  [theme.breakpoints.down('sm')]: {
    minWidth: '90vw',
  },

  [theme.breakpoints.up('sm')]: {
    maxWidth: '200px',
    width: '200px',
    '.MuiBox-root': {
      flexDirection: 'column',
      '.MuiBox-root': {
        flexDirection: 'row',
        padding: '20px 5px 20px 20px',
        '.MuiTypography-p3SemiBold': {
          height: '100px',
          overflowY: 'auto',
          fontWeight: 600,
          color: colors.SEBlack,
        },
        button: {
          marginTop: '10px',
        },
      },
    },
  },
}));

export const DateTypography = styled(Grid)(({ theme }) => ({
  ...theme.typography.p3SemiBold,
  color: colors.SEDark,
}));

export const BonusButton = styled(Button)(({ theme }) => ({
  ...theme.typography.p2Bold,
  height: '35px',
  borderRadius: '8px',
  border: '1px solid #000',
  width: '100%',
}));

export const RewardTile = styled(Grid)(({ theme }) => ({
  background: 'linear-gradient(64.45deg, #FFFFFF 16.05%, rgba(248, 248, 248, 0.65) 69.18%)',
  filter:
    'drop-shadow(0px 33.0556px 23.4259px rgba(0, 0, 0, 0.0303704)) drop-shadow(0px 19.6444px 12.7407px rgba(0, 0, 0, 0.0242963)) drop-shadow(0px 10.2px 6.5px rgba(0, 0, 0, 0.02)) drop-shadow(0px 4.15556px 3.25926px rgba(0, 0, 0, 0.0157037)) drop-shadow(0px 0.944444px 1.57407px rgba(0, 0, 0, 0.00962963))',
  borderRadius: '16px',
  border: '#FFFFFF 1px solid',
  padding: '16px',
  '.selected-false': {
    background: 'linear-gradient(64.45deg, #FFFFFF 16.05%, rgba(248, 248, 248, 0.65) 69.18%)',
    padding: '20px',
  },
  '.selected-true': {
    background: `${theme.palette.secondary.main}33`,
    padding: '20px',
  },
  '.infoText-true': {
    color: `${theme.palette.secondary.main} !important`,
  },
  marginBottom: '16px',
  minHeight: '164px',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    margin: '32px 8px 0',
    minHeight: '300px',
    borderRadius: '20px',
    width: '31%',
    position: 'relative',
  },
}));

export const StyledRewardTileOB = styled(Grid)(({ theme }) => ({
  background:
    'linear-gradient(180deg, rgba(254, 240, 195, 0.00) 14.65%, rgba(255, 213, 147, 0.52) 125.59%)',
  filter:
    'drop-shadow(0px 33.0556px 23.4259px rgba(0, 0, 0, 0.0303704)) drop-shadow(0px 19.6444px 12.7407px rgba(0, 0, 0, 0.0242963)) drop-shadow(0px 10.2px 6.5px rgba(0, 0, 0, 0.02)) drop-shadow(0px 4.15556px 3.25926px rgba(0, 0, 0, 0.0157037)) drop-shadow(0px 0.944444px 1.57407px rgba(0, 0, 0, 0.00962963))',
  borderRadius: '16px',
  border: '#FFFFFF 1px solid',
  padding: '16px',
  '.selected-false': {
    background: 'linear-gradient(64.45deg, #FFFFFF 16.05%, rgba(248, 248, 248, 0.65) 69.18%)',
    padding: '20px',
  },
  '.selected-true': {
    background: `${theme.palette.secondary.main}33`,
    padding: '20px',
  },
  '.infoText-true': {
    color: `${theme.palette.secondary.main} !important`,
  },
  marginBottom: '16px',
  minHeight: '164px',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    margin: '32px 8px 0',
    borderRadius: '20px',
    minHeight: '300px',
    width: '31%',
    position: 'relative',
  },
}));

export const UpperBox = styled(Grid)(() => ({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '16px',
  '.MuiButtonBase-root': {
    fontWeight: 700,
    fontSize: '14px',
    lineHeight: '20px',
  },
}));

export const LowerBox = styled(Grid)(() => ({
  '.MuiButtonBase-root': {
    fontWeight: 700,
    fontSize: '14px',
    lineHeight: '20px',
  },
}));

export const TextGrid = styled(Grid)(({ theme }) => ({
  flexWrap: 'nowrap',
  flexDirection: 'column',
  overflowY: 'auto',
  paddingRight: '4px',
  '&::-webkit-scrollbar': {
    width: '8px',
  },
  '&::-webkit-scrollbar-track': {
    background: colors.gray4,
    borderRadius: '12px',
  },
  '&::-webkit-scrollbar-thumb': {
    background: theme.palette.secondary.main,
    borderRadius: '12px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: theme.palette.secondary.main,
  },
}));

export const ButtonGrid = styled(Grid)(() => ({
  position: 'absolute',
  bottom: '14px',
  left: 0,
  right: 0,
  height: '36px',
  borderTop: '32px',
  button: {
    display: 'flex',
    marginTop: 'auto',
    marginLeft: '16px',
    borderRadius: '8px',
    height: '32px',
    width: '90px',
    position: 'absolute',
    bottom: '-4px',
    alignItems: 'center',
  },
}));

export const ButtonGridOB = styled(Grid)(() => ({
  position: 'absolute',
  bottom: '14px',
  left: 0,
  right: 0,
  height: '36px',
  borderTop: '32px',
  button: {
    display: 'flex',
    marginTop: 'auto',
    marginLeft: '16px',
    borderRadius: '8px',
    height: '32px',
    minWidth: '90px',
    position: 'absolute',
    bottom: '-4px',
    alignItems: 'center',
  },
}));

export const BonusOfferingImageBox = styled('span')(() => ({
  height: '26px !important',
  width: '26px !important',
}));

export const TimeGrid = styled(Grid)(() => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const CarouselContent = styled('div')(() => ({
  display: 'flex',
  transition: 'all 250ms linear',
  scrollbarWidth: ' none',
}));

export const CarouselContentWrapper = styled('div')(() => ({
  width: '88%',
  height: '100%',
}));

export const CarouselWrapper = styled('div')(() => ({
  display: 'flex',
  width: '100%',
  overflow: 'hidden',
}));
export const CarouselContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
}));
